import { render, staticRenderFns } from "./YearGoalsTime.vue?vue&type=template&id=3ae16c24&"
import script from "./YearGoalsTime.vue?vue&type=script&lang=js&"
export * from "./YearGoalsTime.vue?vue&type=script&lang=js&"
import style0 from "./YearGoalsTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports